import { ReactNode, createContext, useContext, useState } from 'react';

export enum PaymentInterval {
  MONTH = 'month',
  YEAR = 'year',
}

export type PaymentIntervalType = {
  isAnnualPaymentSelected: boolean;
  setPaymentInterval: (paymentInterval: PaymentInterval) => void;
};

export const PricingContext = createContext<PaymentIntervalType>(
  {} as PaymentIntervalType
);

export const usePricingContext = () => useContext(PricingContext);

export const PricingProvider = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  const [paymentInterval, setPaymentInterval] = useState<PaymentInterval>(
    PaymentInterval.YEAR
  );

  const isAnnualPaymentSelected = paymentInterval === PaymentInterval.YEAR;

  return (
    <PricingContext.Provider
      value={{
        isAnnualPaymentSelected,
        setPaymentInterval,
      }}
    >
      {children}
    </PricingContext.Provider>
  );
};
